export const STRATEGY_ROUTES = {
  STRATEGY: "/strategy",
  STRATEGY_GOALS: "/strategy/goals",
  STRATEGY_ALIGNMENT: "/strategy/alignment",
  STRATEGY_REVIEWS: "/strategy/reviews",
} as const;

export type StrategyRouteKey = keyof typeof STRATEGY_ROUTES;
